import { FC, useEffect, useState } from 'react'
import { Box, styled } from '@mui/material'
import { IProduct, IVideoStream } from '@shared/Types'
import ExploreMediaService from '@internal/services/explore-media'

interface IProps {
  value?: IProduct
}

export const VideoPlayer: FC<IProps> = (props) => {
  const [streamData, setStreamData] = useState<IVideoStream | null>(null)

  useEffect(() => {
    const func = async () => {
      if (!props.value?.ResourceId) return
      const res = await ExploreMediaService.fetchVideoStream(props.value.ResourceId)
      if (!!res[0]) setStreamData(res[0])
    }
    func()
  }, [props.value?.ResourceId])

  return (
    <Box sx={{ position: 'relative', paddingBottom: '56.25%', borderRadius: '8px', overflow: 'hidden' }}>
      <Box sx={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}>
        {streamData?.StreamUrl && <CustomVideo src={streamData.StreamUrl} controls={true} sx={{ boxShadow: 2 }} />}
      </Box>
    </Box>
  )
}

const CustomVideo = styled('video')({
  width: '100%',
  height: '100%',
  objectFit: 'contain',
  backgroundColor: '#979797'
})

export default VideoPlayer
